import { Link } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';
import { Typography } from '@mui/material';

import { NavigationLinkProps } from './types';

const baseClassNames =
  '[&>p]:bg-clip-text [&>p]:text-transparent [&>p]:bg-black-primary hover:[&>p]:bg-accent-gradient-primary-hover active:[&>p]:bg-accent-gradient-primary-active';
const activeClassNames = '[&>p]:bg-accent-gradient-primary-primary';

export const NavigationLink = ({
  href,
  icon,
  label,
  onClick,
  className,
  isActive = false,
  variant = 'desktop',
}: NavigationLinkProps) => {
  if (variant === 'desktop') {
    return (
      <Link
        to={href}
        className={twMerge(
          baseClassNames,
          'flex items-center px-4 py-3',
          isActive && activeClassNames
        )}
      >
        <Typography variant="body1" className="font-bold">
          {label}
        </Typography>
      </Link>
    );
  }

  return (
    <Link
      to={href}
      onClick={onClick}
      className={twMerge(
        baseClassNames,
        'flex items-center gap-2 px-6 py-4 transition-colors',
        className,
        isActive && activeClassNames
      )}
    >
      {icon && <div>{icon}</div>}
      <Typography variant="body1" className="font-bold">
        {label}
      </Typography>
    </Link>
  );
};
